import React from 'react'

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Divider from '@material-ui/core/Divider'
import Collapse from '@material-ui/core/Collapse'

import {useStyles} from '../SideBarStyles.js'
import IconExpandLess from "@material-ui/icons/ExpandLess";
import IconExpandMore from "@material-ui/icons/ExpandMore";
import EmojiTransportationIcon from '@material-ui/icons/EmojiTransportation';
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import {useHistory} from "react-router-dom";

function MyCompany(props) {

    const {DataStore} = props
    const {companyName, idCompany} = DataStore

    const classes = useStyles()
    const [open, setOpen] = React.useState(false)

    let history = useHistory();

    function handleClick() {
        setOpen(!open)
    }

    return (
        <List component="nav" className={classes.appMenu} disablePadding>
            <ListItem button onClick={handleClick} className={classes.menuItem}>
                <ListItemIcon className={classes.menuItemIcon}>
                    <EmojiTransportationIcon/>
                </ListItemIcon>
                <ListItemText primary="Mi empresa" className={classes.menuItemText}/>
                {open ? <IconExpandLess className={classes.openSubMenuIcons}/> :
                    <IconExpandMore className={classes.openSubMenuIcons}/>}
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <Divider classes={{root: classes.divider}}/>
                <List>
                    <ListItem button className={classes.nested}
                              onClick={() => {
                                  history.push("/control-panel/my-company")
                                  DataStore.getTabs('Datos de mi empresa')
                              }}>
                        <FiberManualRecordIcon className={classes.fiberManualRecordIcon}/>
                        <ListItemText primary="Datos de mi empresa" className={classes.subItemsText}/>
                    </ListItem>
                    <ListItem button className={classes.nested}
                              onClick={() => {
                                  history.push("/control-panel/users")
                                  DataStore.getTabs('Crear usuarios')
                              }}>
                        <FiberManualRecordIcon className={classes.fiberManualRecordIcon}/>
                        <ListItemText primary="Crear usuarios" className={classes.subItemsText}/>
                    </ListItem>
                    <ListItem button className={classes.nested}
                              onClick={() => {
                                  history.push("/control-panel/users-permissions")
                                  DataStore.getTabs('Permisos del sistema')
                              }}>
                        <FiberManualRecordIcon className={classes.fiberManualRecordIcon}/>
                        <ListItemText primary="Permisos del sistema" className={classes.subItemsText}/>
                    </ListItem>
                    <ListItem button className={classes.nested}
                              onClick={async () => {
                                  history.push("/control-panel/general-values")
                                  DataStore.getTabs('Valores generales')
                                  await DataStore.GeneralValues(companyName, idCompany)
                              }}>
                        <FiberManualRecordIcon className={classes.fiberManualRecordIcon}/>
                        <ListItemText primary="Valores generales" className={classes.subItemsText}/>
                    </ListItem>
                </List>
                <Divider classes={{root: classes.divider}}/>
            </Collapse>
        </List>
    )

}

export default MyCompany
